import type { BackendFunctionsType } from "../../../backend/apiFunctions/functions";
import {
  addPromiseToWindow,
  removePromiseFromWindow,
} from "../app/aiTasks/aiDescription";
import { uid } from "./utils";

export default async function apiFetch<
  K extends keyof BackendFunctionsType,
  F extends keyof ApiFunction<K>
>(
  categoryId: K,
  functionName: F,
  params: Parameters<ApiFunction<K>[F]>[0],
  errorText?: string | null | undefined
): Promise<ReturnType<ApiFunction<K>[F]>> {
  let promiseId = `${uid()}-${categoryId}/${functionName as string}`;
  addPromiseToWindow(promiseId);
  let result = await fetch(
    `${
      process.env.NODE_ENV == "development" ? process.env.BACKEND_BASE_URL : ""
    }/nextApi/${categoryId}/${functionName as string}`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
      body: JSON.stringify(params || {}),
    }
  );
  removePromiseFromWindow(promiseId);

  // duplicateFetches(categoryId, functionName, params,100);

  if (!result.ok) throw new Error(`${result.statusText}`);
  let json = await result.json();

  if (json.error) throw new Error(`${json.error}`);
  // await simulateSlowNetwork(
  //   `${categoryId}/${functionName as string}`,
  //   json.result,
  //   5
  // );

  // console.log(
  //   "size in mb",
  //   categoryId,
  //   functionName,
  //   JSON.stringify(json.result || "{}").length / 1024 / 1024
  // );
  return json.result;
}

async function duplicateFetches(
  categoryId: any,
  functionName: any,
  params: any,
  count: number
) {
  let promises = [];
  for (let i = 0; i < count; i++) {
    promises.push(
      fetch(
        `${
          process.env.NODE_ENV == "development"
            ? process.env.BACKEND_BASE_URL
            : ""
        }/nextApi/${categoryId}/${functionName as string}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
          body: JSON.stringify(params || {}),
        }
      )
    );
  }
  await Promise.all(promises);
}

async function simulateSlowNetwork(
  name: string,
  json: any,
  kbsPerSecond: number
) {
  if (process.env.NODE_ENV !== "development") return;
  let length = JSON.stringify(json)?.length;
  let kb = parseInt((length / 1024).toString());
  console.log(`${name?.replace("general/", "")} ${kb}KB`, json);
  await sleep((kb / kbsPerSecond) * 1000);
}

export async function sleep(delayInms: number) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(2);
    }, delayInms);
  });
}

type ApiFunction<K extends keyof BackendFunctionsType> = {
  [F in keyof BackendFunctionsType[K]]: BackendFunctionsType[K][F] extends (
    params: infer P
  ) => Promise<infer R>
    ? (params: P) => R
    : never;
};
